<template>
  <product
    :product-logo="productLogo"
    :product-brief="productBrief"
    :carousel-items-no="1"
    :carousel-images="carouselImages"
  >
    <p>
      This SaaS platform is a Video CMS for clinics and health centers
      to show promotional and/or other kinds of videos through the app
      on Apple TV (tvOS). It replaced an aging platform with fewer
      features and less content. My part of the job was to develop an
      API for a tvOS app and a Dashboard for admins/moderators to be
      able to manage their videos.
    </p>
    <p>
      In more details, we needed to do the following:
      <ul>
        <li>
          Create a dashboard for both app admin and customers with access
          restrictions for the latter.
        </li>
        <li>
          Create Registration and approval for customers.
        </li>
        <li>
          Configure seamless flow for video uploads and managing.
        </li>
        <li>
          Build an approval mechanism for uploaded videos.
        </li>
        <li>
          Creating an API for an authorized tvOS app, that serves videos
          filtered by region, public availability, access level, and
          priority
        </li>
      </ul>
    </p>
    <p>
      The app continues to serve the needs of users and we've done
      additional sprints with updates such as rendering video with
      custom text based on a template, encoding for uploaded videos, and
      more…
    </p>
    <p>
      The app is rapidly growing so we've recently built an internal
      analytics dashboard to get more sense of what's going on in the
      platform.
    </p>
    <template v-slot:footer>
      <div class="col-12 mt-3 py-2 next-btn">
        <router-link :to="{ name: 'blue-nile' }">
          <span>Next &mdash; Blue Nile kiosk app</span>
          <font-awesome-icon icon="arrow-right" size="3x" />
        </router-link>
      </div>
    </template>
  </product>
</template>

<script>
import Product from '@/components/product/Product'
export default {
  components: { Product },
  data() {
    return {
      productLogo: require('@/assets/img/products/MaxTV2.png'),
      productBrief: 'Showcase your products, infographics, recipes, and custom uploaded videos at the heart of your clinic.',
      carouselImages: [
        require('@/assets/img/products/mxtv/1.png'),
        require('@/assets/img/products/mxtv/2.png'),
        require('@/assets/img/products/mxtv/3.png'),
        require('@/assets/img/products/mxtv/4.png'),
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/components/product/details";

section.main {
  background-image: linear-gradient(#c76b4624, #c76b4614),
    url("~@/assets/img/products/mxtv/cover.jpg");
  background-position-y: top;
  background-position-x: center;
}
</style>
